module.exports = __webpack_public_path__ + "static/media/selfie.c8d05144.jpg";